const companyInfoConfirm = r => require.ensure([], () => r(require('@/page/companyInfoConfirm/companyInfoConfirm')), 'companyInfoConfirm');
const companySureOrView = r => require.ensure([], () => r(require('@/page/companyInfoConfirm/companySureOrView')), 'companySureOrView');
const companyInfoConfirmView = r => require.ensure([], () => r(require('@/page/companyInfoConfirm/companyInfoConfirmView')), 'companyInfoConfirmView');

const companyInfoConfirmRouter = {
    path: '',
    name: '企业信息确认',
    component: companyInfoConfirmView,
    meta: {
        right: [],
        isShowMenu: true,
        icon: 'organMge',
    },
    children: [
        {
            path: '/companyInfoConfirm',
            component: companyInfoConfirm,
            name: '市企业信息确认',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: true,
            },
        },
        {
          path: '/companySureOrView',
          component: companySureOrView,
          name: '企业信息确认',
          meta: {
              right: [],
              isShowMenu: false,
              keepAlive: false,
          },
      },
    ]
};
export default companyInfoConfirmRouter;